import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Complete1 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_05.png';
import Complete2 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_06.png';
import Complete3 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_07.png';
import Complete4 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_08.png';
import Complete5 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_09.png';
import Complete6 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_10.png';
import Complete7 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_11.png';
import Complete8 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_12.png';
import Complete9 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_13.png';
import Complete10 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_14.png';
import Complete11 from '../../assets/online_payment_pay_complete_check/online_payment_pay_complete_check_15.png';
import { useEffect, useState } from 'react';
import { postMessageToParent } from '../../utils/postMessage';
import {
  PAYMENT_STATUS,
  POST_MESSAGE_TYPE
} from '../../common/constants';
import { useLocation } from 'react-router-dom';
import SamsungPayBox from "../../components/common/SamsungPayBox";
import SamsungPayHeader from "../../components/common/SamsungPayHeader";
import { useSelector } from 'react-redux';
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';
import { persistor } from '../../utils/store';

const cx = classNames.bind(styles);

export default function DonePage() {
  const { sourceOrigin, serviceId, merchantName } = useSelector((state) => state.paymentClient);
  const location = useLocation();
  const {t} = useTranslation();
  const paymentCredential = location.state?.paymentCredential;
  const cookieData = location.state?.cookie;
  const referenceId = location.state?.referenceId;
  const doneImages = [
    Complete1, Complete2, Complete3, Complete4, Complete5, Complete6, Complete7, Complete8, Complete9, Complete10, Complete11
  ];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    if (currentImage >= doneImages.length - 1) {
      return;
    }
    const timer = setInterval(() => {
      setCurrentImage((prevImage) => prevImage + 1);
    }, 50);
    return () => clearInterval(timer);
  }, [currentImage]);

  useEffect(() => {
    const timer = setTimeout(() => {
      postMessageToParent({
        type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
        content: {
          status: PAYMENT_STATUS.SUCCESS,
          data: paymentCredential,
          cookie: cookieData,
          notificationContent: {
            payment: {
              service: {
                id: serviceId
              },
              reference: referenceId,
              status: '',
              provider: ''
            },
            merchant: {
              name: merchantName
            }
          }
        },
        sourceOrigin: sourceOrigin
      });

      persistor.purge();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <SamsungPayBox>
      <SamsungPayHeader headerMessage="pay.gsmpi.done.msg1"/>
      <div className="mpi-dynamic-space-div"></div>
      <div className="mpi-content mpi-step-done">
        <div className="mpi-done">
          <div className="mpi-done-check"><img src={doneImages[currentImage]} alt={`Done Image ${currentImage}`}/></div>
          <div className={cx('mpi-done-text')}>{t('pay.gsmpi.done.msg3')}.</div>
        </div>
      </div>
    </SamsungPayBox>
  );
}